export * from './timepicker.component';
export * from './timepicker.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/time-picker/index.ts